import { defineMessages } from '@jutro/locale';

export default defineMessages({
    policy: {
        id: 'ml.claim.MLClaimSummariesComponent.Policy',
        defaultMessage: 'Policy'
    },
    claimNumber: {
        id: 'ml.claim.MLClaimSummariesComponent.Claim Number',
        defaultMessage: 'Claim Number'
    },
    dateOfLoss: {
        id: 'ml.claim.MLClaimSummariesComponent.Date of Loss',
        defaultMessage: 'Date of Loss'
    },
    status: {
        id: 'ml.claim.MLClaimSummariesComponent.Status',
        defaultMessage: 'Status'
    },
    statusHelpMsg: {
        id: 'ml.claim.MLClaimSummariesComponent.statusHelpMsg',
        defaultMessage: '<p><strong>Open:</strong> Your claim is actively being handled by a Claim Consultant. Contact your Claims Consultant if you have questions regarding your claim.</p><p><strong>Closed:</strong> Your claim is completed.</p><p><strong>Draft:</strong> You reported the claim but did not finish entering all of the required information.</p><p><strong>Archived:</strong> Your claim has been closed and archived. If additional action is necessary, please contact your Claim Consultant.</p><p></p><p>You can contact our Claim Department at 1-800-854-6011.</p>'
    }
});
